import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import type React from 'react';

interface TileCardProps extends React.ComponentProps<'div'> {
  title: string;
  imageUrl?: string;
  imageAlt?: string;
}

export const TileCard: React.FC<TileCardProps> = ({
  title,
  imageUrl,
  imageAlt,
  className,
  ...props
}) => {
  return (
    <div
      className={cn('flex flex-col items-center gap-2', className)}
      {...props}
    >
      <div
        className={cn(
          'relative w-full bg-surface-transparent-2',
          'aspect-square overflow-hidden rounded-5',
          'md:aspect-auto md:h-[200px] md:rounded-6.5',
        )}
      >
        <div className="absolute top-[26px] left-1/2 z-10 hidden w-[90%] -translate-x-1/2 flex-col items-center gap-1 md:flex">
          <Typography.Header150Semibold className="text-center text-text-primary">
            {title}
          </Typography.Header150Semibold>
        </div>

        {imageUrl && (
          <img
            src={imageUrl}
            alt={imageAlt ?? title}
            className={cn(
              'pointer-events-none absolute',
              'inset-0 h-full w-full object-cover',
              'md:inset-x-0 md:top-[35%] md:mx-auto md:h-auto md:w-[80%] md:object-contain',
            )}
          />
        )}
      </div>

      <Typography.Text300Semibold className="w-full text-center text-text-primary md:hidden">
        {title}
      </Typography.Text300Semibold>
    </div>
  );
};
